import config from "./config";


export default {
    taxYear: new Date(Number(config.taxYear),1,1),
    employerName: 'סיטיבוק סרבסיס בע"מ',
    employerAddress: "שד' יחזקאל 2 ,מודיעין עילית 7191904",
    employerPhone: '08-9776000',
    deductionsPortfolio: '943213884'
}